import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _asyncToGenerator from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _regeneratorRuntime from "/home/runner/work/website/website/node_modules/@babel/runtime/regenerator/index.js";
import { FEATURES, buildComponentViewEvent, logger, ConsoleLogSink, buildPageEvent, buildTrackEvent, buildIdentifyEvent, unionBy, pipe, PageviewProperties, Properties, Traits, isPageViewEvent, isTrackEvent, isIdentifyEvent, isComponentViewEvent, selectHasVariants, selectExperience, selectVariant as selectVariant$1, selectBaselineWithVariants, OnLogLogSink, OnErrorLogSink, NinetailedApiClient } from '@ninetailed/experience.js-shared';
export { EXPERIENCE_TRAIT_PREFIX, isExperienceMatch, selectActiveExperiments, selectDistribution, selectExperience, selectBaselineWithVariants as selectExperienceBaselineWithVariants, selectVariant as selectExperienceVariant, selectVariants as selectExperienceVariants, selectHasVariants as selectHasExperienceVariants } from '@ninetailed/experience.js-shared';
import { NinetailedAnalyticsPlugin, HAS_SEEN_COMPONENT, HAS_SEEN_ELEMENT, hasComponentViewTrackingThreshold } from '@ninetailed/experience.js-plugin-analytics';
import Analytics from 'analytics';
import { v4 } from 'uuid';
var COMPONENT = 'component';
var COMPONENT_START = 'componentStart';
var PAGE_HIDDEN = 'page_hidden';
var HAS_SEEN_STICKY_COMPONENT = 'sticky_component_view';
var buildClientLocale = function buildClientLocale() {
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
};
var buildClientNinetailedRequestContext = function buildClientNinetailedRequestContext() {
  return {
    url: window.location.href,
    referrer: document.referrer,
    locale: buildClientLocale(),
    userAgent: navigator.userAgent,
    document: {
      title: document.title
    }
  };
};

/**
 * Similar to _.throttle but waits for the promise to resolve.
 * There is no "wait time" because you can simply await `Promise.timeout` inside `fn` to wait some time before the next call.
 */
function asyncThrottle(fn) {
  var runningPromise;
  var queuedPromise;
  var nextArgs;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!runningPromise) {
              _context.next = 10;
              break;
            }
            nextArgs = args;
            if (!queuedPromise) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return", queuedPromise);
          case 6:
            queuedPromise = runningPromise.then(function () {
              queuedPromise = undefined;
              runningPromise = fn(nextArgs);
              return runningPromise;
            });
            return _context.abrupt("return", queuedPromise);
          case 8:
            _context.next = 12;
            break;
          case 10:
            runningPromise = fn(args);
            return _context.abrupt("return", runningPromise);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
var LEGACY_ANONYMOUS_ID = '__anon_id';
var ANONYMOUS_ID = '__nt_anonymous_id__';
var DEBUG_FLAG = '__nt_debug__';
var PROFILE_FALLBACK_CACHE = '__nt_profile__';
var EXPERIENCES_FALLBACK_CACHE = '__nt_experiences__';
var PROFILE_CHANGE = 'profile-change';
var PROFILE_RESET = 'profile-reset';
var CONSENT = '__nt-consent__';
var SET_ENABLED_FEATURES = 'setEnabledFeatures';
var EMPTY_MERGE_ID = 'nt:empty-merge-id';
var PLUGIN_NAME = 'ninetailed:core';
var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var NinetailedCorePlugin = /*#__PURE__*/function (_NinetailedAnalyticsP) {
  function NinetailedCorePlugin(_ref3) {
    var _this2;
    var apiClient = _ref3.apiClient,
      locale = _ref3.locale,
      ninetailed = _ref3.ninetailed,
      onInitProfileId = _ref3.onInitProfileId,
      buildClientContext = _ref3.buildClientContext;
    _classCallCheck(this, NinetailedCorePlugin);
    var _this;
    _this2 = _callSuper(this, NinetailedCorePlugin);
    _this = _this2;
    _this2.name = PLUGIN_NAME;
    _this2._instance = void 0;
    _this2.queue = [];
    _this2.enabledFeatures = Object.values(FEATURES);
    _this2.buildContext = buildClientNinetailedRequestContext;
    _this2.onInitProfileId = void 0;
    _this2.apiClient = void 0;
    _this2.locale = void 0;
    _this2.ninetailed = void 0;
    _this2[SET_ENABLED_FEATURES] = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              payload = _ref4.payload;
              _this.enabledFeatures = payload.features || [];
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    _this2.getComponentViewTrackingThreshold = function () {
      return 0;
    };
    _this2[HAS_SEEN_STICKY_COMPONENT] = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
        var payload, ctx;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              payload = _ref6.payload;
              ctx = _this.buildContext();
              return _context3.abrupt("return", _this.enqueueEvent(buildComponentViewEvent({
                messageId: payload.meta.rid,
                timestamp: payload.meta.ts,
                componentId: payload.componentId,
                experienceId: payload.experienceId,
                variantIndex: payload.variantIndex,
                ctx: ctx
              })));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }();
    _this2.methods = {
      reset: function () {
        var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
          var _ref8;
          var instance,
            profileId,
            _args4 = arguments;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                logger.debug('Resetting profile.');
                instance = (_ref8 = _args4.length - 1, _ref8 < 0 || _args4.length <= _ref8 ? undefined : _args4[_ref8]);
                instance.dispatch({
                  type: PROFILE_RESET
                });
                instance.storage.removeItem(ANONYMOUS_ID);
                instance.storage.removeItem(PROFILE_FALLBACK_CACHE);
                instance.storage.removeItem(EXPERIENCES_FALLBACK_CACHE);
                logger.debug('Removed old profile data from localstorage.');
                if (!(typeof _this.onInitProfileId === 'function')) {
                  _context4.next = 12;
                  break;
                }
                _context4.next = 10;
                return _this.onInitProfileId(undefined);
              case 10:
                profileId = _context4.sent;
                if (typeof profileId === 'string') {
                  instance.storage.setItem(ANONYMOUS_ID, profileId);
                }
              case 12:
                _context4.next = 14;
                return _this.ninetailed.track('nt_reset');
              case 14:
                logger.info('Profile reset successful.');
                _context4.next = 17;
                return delay(10);
              case 17:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function reset() {
          return _reset.apply(this, arguments);
        }
        return reset;
      }(),
      debug: function () {
        var _debug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
          var _ref9;
          var enabled,
            instance,
            consoleLogSink,
            _args5 = arguments;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                enabled = _args5.length <= 0 ? undefined : _args5[0];
                instance = (_ref9 = _args5.length - 1, _ref9 < 0 || _args5.length <= _ref9 ? undefined : _args5[_ref9]);
                consoleLogSink = new ConsoleLogSink();
                if (enabled) {
                  instance.storage.setItem(DEBUG_FLAG, true);
                  logger.addSink(consoleLogSink);
                  logger.info('Debug mode enabled.');
                } else {
                  instance.storage.removeItem(DEBUG_FLAG);
                  logger.info('Debug mode disabled.');
                  logger.removeSink(consoleLogSink.name);
                }
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function debug() {
          return _debug.apply(this, arguments);
        }
        return debug;
      }()
    };
    _this2.flush = asyncThrottle(_this2._flush.bind(_this2));
    if (onInitProfileId) {
      _this2.onInitProfileId = onInitProfileId;
    }
    if (buildClientContext) {
      _this2.buildContext = buildClientContext;
    }
    _this2.apiClient = apiClient;
    _this2.ninetailed = ninetailed;
    _this2.locale = locale;
    return _this2;
  }
  _inherits(NinetailedCorePlugin, _NinetailedAnalyticsP);
  return _createClass(NinetailedCorePlugin, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref10) {
        var instance, legacyAnonymousId, profileId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              instance = _ref10.instance;
              this._instance = instance;
              if (instance.storage.getItem(DEBUG_FLAG)) {
                logger.addSink(new ConsoleLogSink());
                logger.info('Ninetailed Debug Mode is enabled.');
              }

              // legacy support for the old anonymousId
              legacyAnonymousId = instance.storage.getItem(LEGACY_ANONYMOUS_ID);
              if (legacyAnonymousId) {
                logger.debug('Found legacy anonymousId, migrating to new one.', legacyAnonymousId);
                instance.storage.setItem(ANONYMOUS_ID, legacyAnonymousId);
                instance.storage.removeItem(LEGACY_ANONYMOUS_ID);
              }
              if (!(typeof this.onInitProfileId === 'function')) {
                _context6.next = 10;
                break;
              }
              _context6.next = 8;
              return this.onInitProfileId(instance.storage.getItem(ANONYMOUS_ID));
            case 8:
              profileId = _context6.sent;
              if (typeof profileId === 'string') {
                instance.storage.setItem(ANONYMOUS_ID, profileId);
              }
            case 10:
              logger.debug('Ninetailed Core plugin initialized.');
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function initialize(_x4) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "pageStart",
    value: function pageStart(params) {
      return this.abortNonClientEvents(params);
    }
  }, {
    key: "page",
    value: function () {
      var _page = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref11) {
        var payload, ctx;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              payload = _ref11.payload;
              logger.info('Sending Page event.');
              ctx = this.buildContext();
              return _context7.abrupt("return", this.enqueueEvent(buildPageEvent({
                messageId: payload.meta.rid,
                timestamp: payload.meta.ts,
                properties: payload.properties,
                ctx: ctx
              })));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function page(_x5) {
        return _page.apply(this, arguments);
      }
      return page;
    }()
  }, {
    key: "trackStart",
    value: function trackStart(params) {
      return this.abortNonClientEvents(params);
    }
  }, {
    key: "track",
    value: function () {
      var _track = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref12) {
        var payload, ctx;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              payload = _ref12.payload;
              logger.info('Sending Track event.');
              ctx = this.buildContext();
              return _context8.abrupt("return", this.enqueueEvent(buildTrackEvent({
                messageId: payload.meta.rid,
                timestamp: payload.meta.ts,
                event: payload.event,
                properties: payload.properties,
                ctx: ctx
              })));
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function track(_x6) {
        return _track.apply(this, arguments);
      }
      return track;
    }()
  }, {
    key: "identifyStart",
    value: function identifyStart(params) {
      return this.abortNonClientEvents(params);
    }
  }, {
    key: "identify",
    value: function () {
      var _identify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref13) {
        var payload, ctx;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              payload = _ref13.payload;
              logger.info('Sending Identify event.');
              ctx = this.buildContext();
              if (!(payload.userId === EMPTY_MERGE_ID && (!payload.traits || typeof payload.traits === 'object' && Object.keys(payload.traits).length === 0))) {
                _context9.next = 6;
                break;
              }
              logger.info('Skipping Identify event as no userId and no traits are set.');
              return _context9.abrupt("return");
            case 6:
              return _context9.abrupt("return", this.enqueueEvent(buildIdentifyEvent({
                messageId: payload.meta.rid,
                timestamp: payload.meta.ts,
                traits: payload.traits,
                userId: payload.userId === EMPTY_MERGE_ID ? '' : payload.userId,
                ctx: ctx
              })));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function identify(_x7) {
        return _identify.apply(this, arguments);
      }
      return identify;
    }()
  }, {
    key: "onTrackExperience",
    value: function () {
      var _onTrackExperience = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(properties) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!properties.experience.sticky) {
                _context10.next = 4;
                break;
              }
              _context10.next = 3;
              return this.instance.dispatch({
                type: HAS_SEEN_STICKY_COMPONENT,
                componentId: properties.selectedVariant.id,
                experienceId: properties.experience.id,
                variantIndex: properties.selectedVariantIndex
              });
            case 3:
              this.flush();
            case 4:
              return _context10.abrupt("return", Promise.resolve());
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function onTrackExperience(_x8) {
        return _onTrackExperience.apply(this, arguments);
      }
      return onTrackExperience;
    }()
  }, {
    key: "onTrackComponent",
    value: function onTrackComponent() {
      return Promise.resolve();
    }
  }, {
    key: "setItemStart",
    value: function setItemStart(_ref14) {
      var abort = _ref14.abort,
        payload = _ref14.payload;
      if (![ANONYMOUS_ID, DEBUG_FLAG, PROFILE_FALLBACK_CACHE, EXPERIENCES_FALLBACK_CACHE, CONSENT].includes(payload.key)) {
        return abort();
      }
      return payload;
    }
  }, {
    key: "enqueueEvent",
    value: function () {
      var _enqueueEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(event) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.queue = unionBy([event], this.queue, 'messageId');
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function enqueueEvent(_x9) {
        return _enqueueEvent.apply(this, arguments);
      }
      return enqueueEvent;
    }()
  }, {
    key: "abortNonClientEvents",
    value: function abortNonClientEvents(_ref15) {
      var abort = _ref15.abort,
        payload = _ref15.payload;
      if (typeof window !== 'object') {
        return abort();
      }
      return payload;
    }
  }, {
    key: "instance",
    get: function get() {
      if (!this._instance) {
        throw new Error('Ninetailed Core plugin not initialized.');
      }
      return this._instance;
    }
  }, {
    key: "_flush",
    value: function () {
      var _flush2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var events, anonymousId, _yield$this$apiClient, profile, experiences, fallbackProfile, fallbackExperiences;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              events = Object.assign([], this.queue);
              logger.info('Start flushing events.');
              this.queue = [];
              if (events.length) {
                _context12.next = 5;
                break;
              }
              return _context12.abrupt("return", {
                success: true
              });
            case 5:
              _context12.prev = 5;
              anonymousId = this.instance.storage.getItem(ANONYMOUS_ID);
              _context12.next = 9;
              return this.apiClient.upsertProfile({
                profileId: anonymousId,
                events: events
              }, {
                locale: this.locale,
                enabledFeatures: this.enabledFeatures
              });
            case 9:
              _yield$this$apiClient = _context12.sent;
              profile = _yield$this$apiClient.profile;
              experiences = _yield$this$apiClient.experiences;
              this.instance.storage.setItem(ANONYMOUS_ID, profile.id);
              this.instance.storage.setItem(PROFILE_FALLBACK_CACHE, profile);
              this.instance.storage.setItem(EXPERIENCES_FALLBACK_CACHE, experiences);
              logger.debug('Profile from api: ', profile);
              logger.debug('Experiences from api: ', experiences);
              this.instance.dispatch({
                type: PROFILE_CHANGE,
                profile: profile,
                experiences: experiences
              });
              _context12.next = 20;
              return delay(20);
            case 20:
              return _context12.abrupt("return", {
                success: true
              });
            case 23:
              _context12.prev = 23;
              _context12.t0 = _context12["catch"](5);
              logger.debug('An error occurred during flushing the events: ', _context12.t0);
              fallbackProfile = this.instance.storage.getItem(PROFILE_FALLBACK_CACHE);
              fallbackExperiences = this.instance.storage.getItem(EXPERIENCES_FALLBACK_CACHE) || [];
              if (fallbackProfile) {
                logger.debug('Found a fallback profile - will use this.');
                this.instance.dispatch({
                  type: PROFILE_CHANGE,
                  profile: fallbackProfile,
                  experiences: fallbackExperiences
                });
              } else {
                logger.debug('No fallback profile found - setting profile to null.');
                this.instance.dispatch({
                  type: PROFILE_CHANGE,
                  profile: null,
                  experiences: fallbackExperiences,
                  error: _context12.t0
                });
              }
              return _context12.abrupt("return", {
                success: false
              });
            case 30:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[5, 23]]);
      }));
      function _flush() {
        return _flush2.apply(this, arguments);
      }
      return _flush;
    }()
  }]);
}(NinetailedAnalyticsPlugin);
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var ElementSeenObserver = /*#__PURE__*/function () {
  function ElementSeenObserver(_options) {
    _classCallCheck(this, ElementSeenObserver);
    this._intersectionObserver = void 0;
    this._elementDelays = void 0;
    this._intersectionTimers = void 0;
    this._options = _options;
    this._elementDelays = new WeakMap();
    this._intersectionTimers = new WeakMap();
    if (typeof IntersectionObserver !== 'undefined') {
      this._intersectionObserver = new IntersectionObserver(this.onIntersection.bind(this));
    }
  }
  return _createClass(ElementSeenObserver, [{
    key: "onIntersection",
    value: function onIntersection(entries) {
      var _this3 = this;
      entries.forEach(function (entry) {
        var isIntersecting = entry.isIntersecting,
          target = entry.target;
        if (isIntersecting) {
          var delays = _this3._elementDelays.get(target);
          delays == null || delays.forEach(function (delay) {
            var timeOut = window.setTimeout(function () {
              _this3._options.onElementSeen(target, delay);
            }, delay);
            var currentTimers = _this3._intersectionTimers.get(target) || [];
            _this3._intersectionTimers.set(target, [].concat(_toConsumableArray(currentTimers), [timeOut]));
          });
        } else {
          var timeOuts = _this3._intersectionTimers.get(target);
          timeOuts == null || timeOuts.forEach(function (timeOut) {
            if (typeof timeOut !== 'undefined') {
              window.clearTimeout(timeOut);
            }
          });
        }
      });
    }
  }, {
    key: "observe",
    value: function observe(element, options) {
      var _this$_intersectionOb;
      var delays = this._elementDelays.get(element) || [];
      this._elementDelays.set(element, Array.from(new Set([].concat(_toConsumableArray(delays), [(options == null ? void 0 : options.delay) || 0]))));
      (_this$_intersectionOb = this._intersectionObserver) == null || _this$_intersectionOb.observe(element);
    }
  }, {
    key: "unobserve",
    value: function unobserve(element) {
      var _this$_intersectionOb2;
      (_this$_intersectionOb2 = this._intersectionObserver) == null || _this$_intersectionOb2.unobserve(element);
    }
  }]);
}();
var acceptsCredentials = function acceptsCredentials(plugin) {
  return typeof plugin === 'object' && plugin !== null && 'setCredentials' in plugin && typeof plugin.setCredentials === 'function';
};
var isInterestedInHiddenPage = function isInterestedInHiddenPage(arg) {
  return typeof arg === 'object' && arg !== null && PAGE_HIDDEN in arg && typeof arg[PAGE_HIDDEN] === 'function';
};
var decodeExperienceVariantsMap = function decodeExperienceVariantsMap(encodedExperienceVariantsMap) {
  return encodedExperienceVariantsMap.split(',').map(function (experienceIdWithVariant) {
    var _experienceIdWithVari = experienceIdWithVariant.split('='),
      _experienceIdWithVari2 = _slicedToArray(_experienceIdWithVari, 2),
      experienceId = _experienceIdWithVari2[0],
      _variantIndex = _experienceIdWithVari2[1];
    var variantIndex = parseInt(_variantIndex);
    if (!experienceId || !variantIndex) {
      return null;
    }
    return {
      experienceId: experienceId,
      variantIndex: variantIndex
    };
  }).filter(function (x) {
    return !!x;
  }).reduce(function (acc, curr) {
    return Object.assign({}, acc, _defineProperty({}, curr.experienceId, curr.variantIndex));
  }, {});
};
var OnChangeEmitter = /*#__PURE__*/function () {
  function OnChangeEmitter() {
    _classCallCheck(this, OnChangeEmitter);
    this.onChangeListeners = [];
  }
  return _createClass(OnChangeEmitter, [{
    key: "addListener",
    value: function addListener(listener) {
      var _this4 = this;
      this.onChangeListeners.push(listener);
      return function () {
        _this4.removeOnChangeListener(listener);
      };
    }
  }, {
    key: "invokeListeners",
    value: function invokeListeners() {
      this.onChangeListeners.forEach(function (listener) {
        return listener();
      });
    }
  }, {
    key: "removeOnChangeListener",
    value: function removeOnChangeListener(listener) {
      this.onChangeListeners = this.onChangeListeners.filter(function (l) {
        return l !== listener;
      });
    }
  }]);
}();
var hasOnChangeEmitter = function hasOnChangeEmitter(arg) {
  return typeof arg === 'object' && arg !== null && 'onChangeEmitter' in arg && typeof arg.onChangeEmitter === 'object' && arg.onChangeEmitter !== null && arg.onChangeEmitter.constructor === OnChangeEmitter;
};
var selectPluginsHavingOnChangeEmitter = function selectPluginsHavingOnChangeEmitter(plugins) {
  var filteredPlugins = [];
  var _iterator = _createForOfIteratorHelper(plugins),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var plugin = _step.value;
      if (hasOnChangeEmitter(plugin)) {
        filteredPlugins.push(plugin);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return filteredPlugins;
};
var hasExperienceSelectionMiddleware = function hasExperienceSelectionMiddleware(arg) {
  return typeof arg === 'object' && arg !== null && 'getExperienceSelectionMiddleware' in arg && typeof arg.getExperienceSelectionMiddleware === 'function';
};
var selectPluginsHavingExperienceSelectionMiddleware = function selectPluginsHavingExperienceSelectionMiddleware(plugins) {
  var filteredPlugins = [];
  var _iterator2 = _createForOfIteratorHelper(plugins),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var plugin = _step2.value;
      if (hasExperienceSelectionMiddleware(plugin)) {
        filteredPlugins.push(plugin);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return filteredPlugins;
};
var createPassThroughMiddleware = function createPassThroughMiddleware() {
  return function (_ref16) {
    var experience = _ref16.experience,
      variant = _ref16.variant,
      variantIndex = _ref16.variantIndex;
    return {
      experience: experience,
      variant: variant,
      variantIndex: variantIndex
    };
  };
};
var makeExperienceSelectMiddleware = function makeExperienceSelectMiddleware(_ref17) {
  var plugins = _ref17.plugins,
    onChange = _ref17.onChange,
    experiences = _ref17.experiences,
    baseline = _ref17.baseline,
    profile = _ref17.profile;
  var removeChangeListeners = [];
  var pluginsHavingChangeEmitters = selectPluginsHavingOnChangeEmitter(plugins);
  var prepareMiddleware = function prepareMiddleware() {
    if (profile === null) {
      return createPassThroughMiddleware();
    }
    var pluginsWithMiddleware = selectPluginsHavingExperienceSelectionMiddleware(plugins);
    var middlewareFunctions = pluginsWithMiddleware.map(function (plugin) {
      return plugin.getExperienceSelectionMiddleware({
        experiences: experiences,
        baseline: baseline
      });
    });
    return pipe.apply(void 0, _toConsumableArray(middlewareFunctions));
  };
  var middleware = prepareMiddleware();
  var addListeners = function addListeners() {
    removeChangeListeners = pluginsHavingChangeEmitters.map(function (plugin) {
      var listener = function listener() {
        onChange(middleware);
      };
      return plugin.onChangeEmitter.addListener(listener);
    });
  };
  var removeListeners = function removeListeners() {
    removeChangeListeners.forEach(function (listener) {
      return listener();
    });
  };
  return {
    addListeners: addListeners,
    removeListeners: removeListeners,
    middleware: middleware
  };
};
var EventBuilder = /*#__PURE__*/function () {
  function EventBuilder(buildRequestContext) {
    _classCallCheck(this, EventBuilder);
    this.buildRequestContext = void 0;
    this.buildRequestContext = buildRequestContext || buildClientNinetailedRequestContext;
  }
  return _createClass(EventBuilder, [{
    key: "page",
    value: function page(properties, data) {
      return buildPageEvent(Object.assign({
        messageId: (data == null ? void 0 : data.messageId) || v4()
      }, data, {
        timestamp: Date.now(),
        properties: properties || {},
        ctx: this.buildRequestContext()
      }));
    }
  }, {
    key: "track",
    value: function track(event, properties, data) {
      return buildTrackEvent(Object.assign({
        messageId: (data == null ? void 0 : data.messageId) || v4(),
        timestamp: Date.now()
      }, data, {
        event: event,
        properties: properties || {},
        ctx: this.buildRequestContext()
      }));
    }
  }, {
    key: "identify",
    value: function identify(userId, traits, data) {
      return buildIdentifyEvent(Object.assign({
        messageId: (data == null ? void 0 : data.messageId) || v4(),
        timestamp: Date.now()
      }, data, {
        traits: traits || {},
        userId: userId || '',
        ctx: this.buildRequestContext()
      }));
    }
  }, {
    key: "component",
    value: function component(componentId, experienceId, variantIndex, data) {
      return buildComponentViewEvent(Object.assign({
        messageId: (data == null ? void 0 : data.messageId) || v4(),
        timestamp: Date.now()
      }, data, {
        componentId: componentId,
        experienceId: experienceId || '',
        variantIndex: variantIndex || 0,
        ctx: this.buildRequestContext()
      }));
    }
  }]);
}();
var _excluded = ["experience", "variant", "variantIndex"],
  _excluded2 = ["element"];
var buildOverrideMiddleware = function buildOverrideMiddleware(experienceSelectionMiddleware) {
  return function (_ref) {
    var originalExperience = _ref.experience,
      originalVariant = _ref.variant,
      originalVariantIndex = _ref.variantIndex,
      other = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _experienceSelectionM = experienceSelectionMiddleware({
        experience: originalExperience,
        variant: originalVariant,
        variantIndex: originalVariantIndex
      }),
      experience = _experienceSelectionM.experience,
      variant = _experienceSelectionM.variant,
      variantIndex = _experienceSelectionM.variantIndex;
    return Object.assign({}, other, {
      audience: experience != null && experience.audience ? experience.audience : null,
      experience: experience,
      variant: variant,
      variantIndex: variantIndex
    });
  };
};
var Ninetailed = /*#__PURE__*/function () {
  function Ninetailed(ninetailedApiClientInstanceOrOptions) {
    var _this5 = this;
    var _ref18 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      plugins = _ref18.plugins,
      url = _ref18.url,
      locale = _ref18.locale,
      requestTimeout = _ref18.requestTimeout,
      onLog = _ref18.onLog,
      onError = _ref18.onError,
      buildClientContext = _ref18.buildClientContext,
      onInitProfileId = _ref18.onInitProfileId,
      _ref18$componentViewT = _ref18.componentViewTrackingThreshold,
      componentViewTrackingThreshold = _ref18$componentViewT === void 0 ? 2000 : _ref18$componentViewT,
      storageImpl = _ref18.storageImpl,
      _ref18$useSDKEvaluati = _ref18.useSDKEvaluation,
      useSDKEvaluation = _ref18$useSDKEvaluati === void 0 ? false : _ref18$useSDKEvaluati;
    _classCallCheck(this, Ninetailed);
    var _this = this;
    this.instance = void 0;
    this._profileState = void 0;
    this.isInitialized = false;
    this.apiClient = void 0;
    this.ninetailedCorePlugin = void 0;
    this.elementSeenObserver = void 0;
    this.observedElements = void 0;
    this.clientId = void 0;
    this.environment = void 0;
    this.plugins = void 0;
    this.logger = void 0;
    this.componentViewTrackingThreshold = void 0;
    this.useSDKEvaluation = void 0;
    this.eventBuilder = void 0;
    this.page = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(data, options) {
        var result;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              result = PageviewProperties.partial().default({}).safeParse(data);
              if (result.success) {
                _context13.next = 4;
                break;
              }
              throw new Error("[Validation Error] \"page\" was called with invalid params. Page data is not valid: ".concat(result.error.format()));
            case 4:
              _context13.next = 6;
              return _this.waitUntilInitialized();
            case 6:
              _context13.next = 8;
              return _this.instance.page(data, _this.buildOptions(options));
            case 8:
              return _context13.abrupt("return", _this.ninetailedCorePlugin.flush());
            case 11:
              _context13.prev = 11;
              _context13.t0 = _context13["catch"](0);
              logger.error(_context13.t0);
              if (!(_context13.t0 instanceof RangeError)) {
                _context13.next = 16;
                break;
              }
              throw new Error("[Validation Error] \"page\" was called with invalid params. Could not validate due to \"RangeError: Maximum call stack size exceeded\". This can be caused by passing a cyclic data structure as a parameter. Refrain from passing a cyclic data structure or sanitize it beforehand.");
            case 16:
              throw _context13.t0;
            case 17:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[0, 11]]);
      }));
      return function (_x10, _x11) {
        return _ref19.apply(this, arguments);
      };
    }();
    this.track = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(event, properties, options) {
        var result;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              result = Properties.default({}).safeParse(properties);
              if (result.success) {
                _context14.next = 4;
                break;
              }
              throw new Error("[Validation Error] \"track\" was called with invalid params. Properties are no valid json object: ".concat(result.error.format()));
            case 4:
              _context14.next = 6;
              return _this.waitUntilInitialized();
            case 6:
              _context14.next = 8;
              return _this.instance.track(event.toString(), result.data, _this.buildOptions(options));
            case 8:
              return _context14.abrupt("return", _this.ninetailedCorePlugin.flush());
            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](0);
              logger.error(_context14.t0);
              if (!(_context14.t0 instanceof RangeError)) {
                _context14.next = 16;
                break;
              }
              throw new Error("[Validation Error] \"track\" was called with invalid params. Could not validate due to \"RangeError: Maximum call stack size exceeded\". This can be caused by passing a cyclic data structure as a parameter. Refrain from passing a cyclic data structure or sanitize it beforehand.");
            case 16:
              throw _context14.t0;
            case 17:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[0, 11]]);
      }));
      return function (_x12, _x13, _x14) {
        return _ref20.apply(this, arguments);
      };
    }();
    this.identify = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(uid, traits, options) {
        var result;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              result = Traits.default({}).safeParse(traits);
              if (result.success) {
                _context15.next = 4;
                break;
              }
              throw new Error("[Validation Error] \"identify\" was called with invalid params. Traits are no valid json: ".concat(result.error.format()));
            case 4:
              _context15.next = 6;
              return _this.waitUntilInitialized();
            case 6:
              _context15.next = 8;
              return _this.instance.identify(uid && uid.toString() !== '' ? uid.toString() : EMPTY_MERGE_ID, result.data, _this.buildOptions(options));
            case 8:
              return _context15.abrupt("return", _this.ninetailedCorePlugin.flush());
            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15["catch"](0);
              logger.error(_context15.t0);
              if (!(_context15.t0 instanceof RangeError)) {
                _context15.next = 16;
                break;
              }
              throw new Error("[Validation Error] \"identify\" was called with invalid params. Could not validate due to \"RangeError: Maximum call stack size exceeded\". This can be caused by passing a cyclic data structure as a parameter. Refrain from passing a cyclic data structure or sanitize it beforehand.");
            case 16:
              throw _context15.t0;
            case 17:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 11]]);
      }));
      return function (_x15, _x16, _x17) {
        return _ref21.apply(this, arguments);
      };
    }();
    this.batch = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(events) {
        var promises;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return _this.waitUntilInitialized();
            case 3:
              promises = events.map(function (event) {
                if (isPageViewEvent(event)) {
                  return _this.instance.page(event.properties);
                }
                if (isTrackEvent(event)) {
                  return _this.instance.track(event.event, event.properties);
                }
                if (isIdentifyEvent(event)) {
                  return _this.instance.identify(event.userId || EMPTY_MERGE_ID, event.traits);
                }
                if (isComponentViewEvent(event)) {
                  return _this.instance.dispatch({
                    experienceId: event.experienceId,
                    componentId: event.componentId,
                    variantIndex: event.variantIndex,
                    type: HAS_SEEN_STICKY_COMPONENT
                  });
                }
                return Promise.resolve();
              });
              _context16.next = 6;
              return Promise.all(promises);
            case 6:
              return _context16.abrupt("return", _this.ninetailedCorePlugin.flush());
            case 9:
              _context16.prev = 9;
              _context16.t0 = _context16["catch"](0);
              logger.error(_context16.t0);
              if (!(_context16.t0 instanceof RangeError)) {
                _context16.next = 14;
                break;
              }
              throw new Error("[Validation Error] \"batch\" was called with invalid params. Could not validate due to \"RangeError: Maximum call stack size exceeded\". This can be caused by passing a cyclic data structure as a parameter. Refrain from passing a cyclic data structure or sanitize it beforehand.");
            case 14:
              throw _context16.t0;
            case 15:
            case "end":
              return _context16.stop();
          }
        }, _callee16, null, [[0, 9]]);
      }));
      return function (_x18) {
        return _ref22.apply(this, arguments);
      };
    }();
    this.trackStickyComponentView = /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref23) {
        var experienceId, componentId, variantIndex;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              experienceId = _ref23.experienceId, componentId = _ref23.componentId, variantIndex = _ref23.variantIndex;
              _context17.prev = 1;
              _context17.next = 4;
              return _this.waitUntilInitialized();
            case 4:
              _context17.next = 6;
              return _this.instance.dispatch({
                experienceId: experienceId,
                componentId: componentId,
                variantIndex: variantIndex,
                type: HAS_SEEN_STICKY_COMPONENT
              });
            case 6:
              return _context17.abrupt("return", _this.ninetailedCorePlugin.flush());
            case 9:
              _context17.prev = 9;
              _context17.t0 = _context17["catch"](1);
              logger.error(_context17.t0);
              if (!(_context17.t0 instanceof RangeError)) {
                _context17.next = 14;
                break;
              }
              throw new Error("[Validation Error] \"trackStickyComponentView\" was called with invalid params. Could not validate due to \"RangeError: Maximum call stack size exceeded\". This can be caused by passing a cyclic data structure as a parameter. Refrain from passing a cyclic data structure or sanitize it beforehand.");
            case 14:
              throw _context17.t0;
            case 15:
            case "end":
              return _context17.stop();
          }
        }, _callee17, null, [[1, 9]]);
      }));
      return function (_x19) {
        return _ref24.apply(this, arguments);
      };
    }();
    /**
     * @deprecated The legacy datamodel is not recommended anymore
     * Will be removed in the next version of the SDK
     */
    this.trackHasSeenComponent = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(properties) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", _this.instance.dispatch(Object.assign({}, properties, {
                type: HAS_SEEN_COMPONENT
              })));
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function (_x20) {
        return _ref25.apply(this, arguments);
      };
    }();
    this.trackComponentView = function (properties) {
      return _this5.instance.dispatch(Object.assign({}, properties, {
        type: HAS_SEEN_ELEMENT,
        // TODO this is a temporary solution - to not make the user specify a delay
        seenFor: _this5.componentViewTrackingThreshold
      }));
    };
    this.observeElement = function (payload, options) {
      var element = payload.element,
        remaingPayload = _objectWithoutPropertiesLoose(payload, _excluded2);
      if (!(element instanceof Element)) {
        var isObject = typeof element === 'object' && element !== null;
        var constructorName = isObject ? element.constructor.name : '';
        var isConstructorNameNotObject = constructorName && constructorName !== 'Object';
        logger.warn("ElementSeenObserver.observeElement was called with an invalid element. Expected an Element but got ".concat(typeof element).concat(isConstructorNameNotObject ? " of type ".concat(constructorName) : '', ". This call will be ignored."));
      } else {
        var existingPayloads = _this5.observedElements.get(element);
        var delays = _this5.pluginsWithCustomComponentViewThreshold.map(function (plugin) {
          return plugin.getComponentViewTrackingThreshold();
        });
        var uniqueDelays = Array.from(new Set([].concat(_toConsumableArray(delays), [options == null ? void 0 : options.delay])));
        if (!existingPayloads) {
          _this5.observedElements.set(element, [remaingPayload]);
        } else {
          var isPayloadAlreadyObserved = existingPayloads.some(function (payload) {
            return JSON.stringify(payload) === JSON.stringify(remaingPayload);
          });
          if (isPayloadAlreadyObserved) {
            return;
          }
          _this5.observedElements.set(element, [].concat(_toConsumableArray(existingPayloads), [remaingPayload]));
        }
        uniqueDelays.forEach(function (delay) {
          _this5.elementSeenObserver.observe(element, {
            delay: delay
          });
        });
      }
    };
    this.unobserveElement = function (element) {
      _this5.observedElements.delete(element);
      _this5.elementSeenObserver.unobserve(element);
    };
    this.onElementSeen = function (element, delay) {
      var payloads = _this5.observedElements.get(element);
      if (Array.isArray(payloads) && payloads.length > 0) {
        var _iterator3 = _createForOfIteratorHelper(payloads),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var payload = _step3.value;
            _this5.instance.dispatch(Object.assign({}, payload, {
              element: element,
              type: HAS_SEEN_ELEMENT,
              seenFor: delay
            }));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    };
    this.reset = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      return _regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _this.waitUntilInitialized();
          case 2:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            _this.instance.plugins[PLUGIN_NAME].reset();
          case 3:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    this.debug = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(enabled) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this.waitUntilInitialized();
            case 2:
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              _this.instance.plugins[PLUGIN_NAME].debug(enabled);
            case 3:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x21) {
        return _ref27.apply(this, arguments);
      };
    }();
    this.onProfileChange = function (cb) {
      cb(_this5.profileState);
      return _this5.instance.on(PROFILE_CHANGE, function (_ref28) {
        var payload = _ref28.payload;
        if (payload.error) {
          cb(Object.assign({}, _this5._profileState, {
            status: 'error',
            profile: payload.profile,
            experiences: payload.experiences,
            error: payload.error
          }));
        } else {
          cb(Object.assign({}, _this5._profileState, {
            status: 'success',
            profile: payload.profile,
            experiences: payload.experiences,
            error: null
          }));
        }
      });
    };
    this.onSelectVariant = function (_ref29, cb) {
      var baseline = _ref29.baseline,
        experiences = _ref29.experiences;
      var middlewareChangeListeners = [];
      var state = null;
      var removeMiddlewareChangeListeners = function removeMiddlewareChangeListeners() {
        middlewareChangeListeners.forEach(function (removeListener) {
          return removeListener();
        });
        middlewareChangeListeners = [];
      };
      var setSelectedVariant = function setSelectedVariant(newState) {
        state = newState;
        cb(state);
      };
      var removeProfileChangeListener = _this5.onProfileChange(function (profileState) {
        var _makeExperienceSelect = makeExperienceSelectMiddleware({
            plugins: _this5.plugins,
            experiences: experiences,
            baseline: baseline,
            profile: profileState.profile,
            onChange: function onChange(middleware) {
              var overrideResult = buildOverrideMiddleware(middleware);
              if (state !== null) {
                setSelectedVariant(overrideResult(state));
              }
            }
          }),
          addListeners = _makeExperienceSelect.addListeners,
          removeListeners = _makeExperienceSelect.removeListeners,
          experienceSelectionMiddleware = _makeExperienceSelect.middleware;
        addListeners();
        middlewareChangeListeners.push(removeListeners);
        var overrideResult = buildOverrideMiddleware(experienceSelectionMiddleware);
        var hasVariants = experiences.map(function (experience) {
          return selectHasVariants(experience, baseline);
        }).reduce(function (acc, curr) {
          return acc || curr;
        }, false);
        var baseReturn = Object.assign({}, profileState, {
          hasVariants: hasVariants,
          baseline: baseline
        });
        var emptyReturn = Object.assign({}, baseReturn, {
          experience: null,
          variant: baseline,
          variantIndex: 0,
          audience: null,
          isPersonalized: false,
          profile: null,
          error: null
        });
        if (profileState.status === 'loading') {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: true,
            status: 'loading'
          })));
          return;
        }
        if (profileState.status === 'error') {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: false,
            status: 'error',
            error: profileState.error
          })));
          return;
        }
        var profile = profileState.profile,
          selectedExperiences = profileState.experiences;
        if (!profile || !selectedExperiences) {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: false,
            status: 'error',
            error: new Error('No Profile or Selected Experiences were returned by the API')
          })));
          return;
        }
        if (_this5.useSDKEvaluation) {
          var _experience = selectExperience({
            experiences: experiences,
            profile: profile
          });
          if (!_experience) {
            setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
              loading: false,
              status: 'success',
              profile: profile
            })));
            return;
          }
          var _selectVariant$ = selectVariant$1({
              baseline: baseline,
              experience: _experience,
              profile: profile
            }),
            _variant = _selectVariant$.variant,
            index = _selectVariant$.index;
          setSelectedVariant(overrideResult(Object.assign({}, baseReturn, {
            status: 'success',
            loading: false,
            error: null,
            experience: _experience,
            variant: _variant,
            variantIndex: index,
            audience: _experience.audience ? _experience.audience : null,
            profile: profile,
            isPersonalized: true
          })));
          return;
        }
        var experience = experiences.find(function (experience) {
          return selectedExperiences.some(function (selectedExperience) {
            return selectedExperience.experienceId === experience.id;
          });
        });
        var selectedExperience = selectedExperiences.find(function (_ref30) {
          var experienceId = _ref30.experienceId;
          return experienceId === (experience == null ? void 0 : experience.id);
        });
        if (!experience || !selectedExperience) {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: false,
            status: 'success',
            profile: profile
          })));
          return;
        }
        var baselineVariants = selectBaselineWithVariants(experience, baseline);
        if (!baselineVariants) {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: false,
            status: 'success',
            profile: profile
          })));
          return;
        }
        var variants = baselineVariants.variants;
        var variant = [baseline].concat(_toConsumableArray(variants))[selectedExperience.variantIndex];
        if (!variant) {
          setSelectedVariant(overrideResult(Object.assign({}, emptyReturn, {
            loading: false,
            status: 'success',
            profile: profile
          })));
          return;
        }
        setSelectedVariant(overrideResult(Object.assign({}, baseReturn, {
          status: 'success',
          loading: false,
          error: null,
          experience: experience,
          variant: variant,
          variantIndex: selectedExperience.variantIndex,
          audience: experience.audience ? experience.audience : null,
          profile: profile,
          isPersonalized: true
        })));
      });
      return function () {
        removeProfileChangeListener();
        removeMiddlewareChangeListeners();
      };
    };
    this.onIsInitialized = function (onIsInitialized) {
      if (typeof onIsInitialized === 'function') {
        if (_this5.isInitialized) {
          onIsInitialized();
        } else {
          var detachOnReadyListener = _this5.instance.on('ready', function () {
            _this5.isInitialized = true;
            onIsInitialized();
            detachOnReadyListener();
          });
        }
      }
    };
    this.waitUntilInitialized = function () {
      return new Promise(function (resolve) {
        _this5.onIsInitialized(resolve);
      });
    };
    this.onVisibilityChange = function () {
      if (typeof document === 'undefined') {
        return;
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          _this5.instance.dispatch({
            type: PAGE_HIDDEN
          });
        }
      });
    };
    if (typeof onLog === 'function') {
      logger.addSink(new OnLogLogSink(onLog));
    }
    if (typeof onError === 'function') {
      logger.addSink(new OnErrorLogSink(onError));
    }
    this.logger = logger;
    this.useSDKEvaluation = useSDKEvaluation;
    if (ninetailedApiClientInstanceOrOptions instanceof NinetailedApiClient) {
      this.apiClient = ninetailedApiClientInstanceOrOptions;
    } else {
      var clientId = ninetailedApiClientInstanceOrOptions.clientId,
        environment = ninetailedApiClientInstanceOrOptions.environment,
        preview = ninetailedApiClientInstanceOrOptions.preview;
      this.clientId = clientId;
      this.environment = environment || 'main';
      this.apiClient = new NinetailedApiClient({
        clientId: clientId,
        environment: environment,
        url: url,
        preview: preview
      });
    }
    this.plugins = (plugins != null ? plugins : []).flat();
    this.plugins.forEach(function (plugin) {
      if (acceptsCredentials(plugin) && _this5.clientId && _this5.environment) {
        plugin.setCredentials({
          clientId: _this5.clientId,
          environment: _this5.environment
        });
      }
      if (hasComponentViewTrackingThreshold(plugin)) {
        plugin.setComponentViewTrackingThreshold(componentViewTrackingThreshold);
      }
    });
    this._profileState = {
      status: 'loading',
      profile: null,
      experiences: null,
      error: null,
      from: 'api'
    };
    this.eventBuilder = new EventBuilder(buildClientContext);
    this.ninetailedCorePlugin = new NinetailedCorePlugin({
      apiClient: this.apiClient,
      locale: locale,
      requestTimeout: requestTimeout,
      buildClientContext: buildClientContext,
      onInitProfileId: onInitProfileId,
      ninetailed: this
    });
    this.instance = Analytics(Object.assign({
      app: 'ninetailed',
      plugins: [].concat(_toConsumableArray(this.plugins), [this.ninetailedCorePlugin])
    }, storageImpl ? {
      storage: storageImpl
    } : {}));
    var _detachOnReadyListener = this.instance.on('ready', function () {
      _this5.isInitialized = true;
      logger.info('Ninetailed Experience.js SDK is completely initialized.');
      _detachOnReadyListener();
    });

    // put in private method
    this.onProfileChange(function (profileState) {
      _this5._profileState = profileState;
      if (typeof window !== 'undefined') {
        window.ninetailed = Object.assign({}, window.ninetailed, {
          profile: _this5.profileState.profile,
          experiences: _this5.profileState.experiences
        });
      }
    });
    this.observedElements = new WeakMap();
    this.elementSeenObserver = new ElementSeenObserver({
      onElementSeen: this.onElementSeen.bind(this)
    });
    this.componentViewTrackingThreshold = componentViewTrackingThreshold;
    var hasPluginsInterestedInHiddenPage = this.plugins.some(isInterestedInHiddenPage);
    if (hasPluginsInterestedInHiddenPage) {
      this.onVisibilityChange();
    }
    this.registerWindowHandlers();
  }
  return _createClass(Ninetailed, [{
    key: "pluginsWithCustomComponentViewThreshold",
    get: function get() {
      return [this.ninetailedCorePlugin].concat(_toConsumableArray(this.plugins)).filter(function (plugin) {
        return hasComponentViewTrackingThreshold(plugin);
      });
    }
  }, {
    key: "profileState",
    get: function get() {
      return this._profileState;
    }
  }, {
    key: "buildOptions",
    value: function buildOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.assign({}, options);
    }
  }, {
    key: "registerWindowHandlers",
    value: function registerWindowHandlers() {
      if (typeof window !== 'undefined') {
        window.ninetailed = Object.assign({}, window.ninetailed, {
          page: this.page.bind(this),
          track: this.track.bind(this),
          identify: this.identify.bind(this),
          reset: this.reset.bind(this),
          debug: this.debug.bind(this),
          profile: this.profileState.profile
        });
      }
    }
  }]);
}();
var selectVariant = function selectVariant(baseline, variants, _ref31) {
  var status = _ref31.status,
    profile = _ref31.profile,
    error = _ref31.error;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    holdout: -1
  };
  if (status === 'loading') {
    return {
      loading: true,
      variant: Object.assign({}, baseline, {
        id: 'baseline',
        audience: {
          id: 'baseline'
        }
      }),
      audience: {
        id: 'baseline'
      },
      isPersonalized: false,
      error: null
    };
  }
  if (status === 'error') {
    return {
      loading: false,
      variant: Object.assign({}, baseline, {
        id: 'baseline',
        audience: {
          id: 'baseline'
        }
      }),
      audience: {
        id: 'baseline'
      },
      isPersonalized: false,
      error: error
    };
  }
  var variant = variants.find(function (variant) {
    var _profile$audiences, _variant$audience;
    return profile == null || (_profile$audiences = profile.audiences) == null ? void 0 : _profile$audiences.includes((_variant$audience = variant.audience) == null ? void 0 : _variant$audience.id);
  });
  if (variant) {
    if (options != null && options.holdout || -1 > ((profile == null ? void 0 : profile.random) || 0)) {
      return {
        loading: false,
        variant: Object.assign({}, baseline, {
          audience: {
            id: 'baseline'
          }
        }),
        audience: Object.assign({}, variant.audience, {
          id: variant.audience.id
        }),
        isPersonalized: false,
        error: null
      };
    }
    return {
      loading: false,
      variant: variant,
      audience: Object.assign({}, variant.audience, {
        id: variant.audience.id
      }),
      isPersonalized: true,
      error: null
    };
  }

  /**
   * There was no matching audience found.
   */
  return {
    loading: false,
    variant: Object.assign({}, baseline, {
      id: 'baseline',
      audience: {
        id: 'baseline'
      }
    }),
    audience: {
      id: 'baseline'
    },
    isPersonalized: false,
    error: null
  };
};
export { ANONYMOUS_ID, COMPONENT, COMPONENT_START, CONSENT, DEBUG_FLAG, EMPTY_MERGE_ID, EXPERIENCES_FALLBACK_CACHE, HAS_SEEN_STICKY_COMPONENT, LEGACY_ANONYMOUS_ID, Ninetailed, NinetailedCorePlugin, OnChangeEmitter, PAGE_HIDDEN, PLUGIN_NAME, PROFILE_CHANGE, PROFILE_FALLBACK_CACHE, PROFILE_RESET, SET_ENABLED_FEATURES, buildClientNinetailedRequestContext, decodeExperienceVariantsMap, makeExperienceSelectMiddleware, selectPluginsHavingExperienceSelectionMiddleware, selectPluginsHavingOnChangeEmitter, selectVariant };